import { Activity, Mail, Linkedin, Instagram } from "lucide-react";

export default function Footer() {
  const scrollTo = (id) => {
    const el = document.querySelector(id);
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <footer
      data-testid="site-footer"
      className="relative pt-24 pb-10 overflow-hidden border-t border-white/5"
    >
      <div className="absolute inset-x-0 top-0 h-px bg-gradient-to-r from-transparent via-cyan-400/40 to-transparent" />
      <div className="absolute -top-40 left-1/2 -translate-x-1/2 w-[600px] h-[400px] rounded-full bg-[#0B3D91]/20 blur-[120px] pointer-events-none" />

      <div className="relative max-w-7xl mx-auto px-6">
        <div className="text-center pb-16 border-b border-white/5">
          <h3 className="font-display text-6xl sm:text-8xl lg:text-9xl font-semibold tracking-tighter text-gradient-cyan leading-none">
            SilentScan AI
          </h3>
          <p className="mt-6 text-lg text-zinc-400 max-w-xl mx-auto">
            Know Before Symptoms Show.
          </p>
        </div>

        <div className="mt-14 grid grid-cols-2 md:grid-cols-4 gap-10">
          <div>
            <div className="flex items-center gap-2">
              <span className="w-8 h-8 rounded-lg bg-gradient-to-br from-[#0B3D91] to-cyan-500 flex items-center justify-center">
                <Activity className="w-4 h-4 text-white" strokeWidth={2.5} />
              </span>
              <span className="font-display font-semibold">SilentScan AI</span>
            </div>
            <p className="mt-4 text-sm text-zinc-500 leading-relaxed">
              An AI-powered preventive healthcare platform for meaningful,
              personalized health awareness.
            </p>
          </div>

          <div>
            <p className="text-xs font-bold uppercase tracking-[0.2em] text-zinc-500">
              Explore
            </p>
            <ul className="mt-4 space-y-2.5 text-sm">
              {[
                { l: "About", h: "#about" },
                { l: "How it works", h: "#how" },
                { l: "Features", h: "#features" },
                { l: "Demo", h: "#demo" },
                { l: "FAQ", h: "#faq" },
              ].map((i) => (
                <li key={i.h}>
                  <button
                    onClick={() => scrollTo(i.h)}
                    className="text-zinc-400 hover:text-cyan-300 transition-colors"
                  >
                    {i.l}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <p className="text-xs font-bold uppercase tracking-[0.2em] text-zinc-500">
              Contact
            </p>
            <ul className="mt-4 space-y-3 text-sm">
              <li>
                <a
                  data-testid="contact-email"
                  href="mailto:nutriplate07@gmail.com"
                  className="flex items-center gap-2 text-zinc-400 hover:text-cyan-300 transition-colors"
                >
                  <Mail className="w-4 h-4" /> nutriplate07@gmail.com
                </a>
              </li>
            </ul>
          </div>

          <div>
            <p className="text-xs font-bold uppercase tracking-[0.2em] text-zinc-500">
              Follow
            </p>
            <div className="mt-4 flex gap-2">
              <a
                data-testid="social-linkedin"
                href="#"
                className="w-10 h-10 rounded-full glass-card flex items-center justify-center hover:border-cyan-400/40 transition-colors"
                aria-label="LinkedIn"
              >
                <Linkedin className="w-4 h-4 text-zinc-300" />
              </a>
              <a
                data-testid="social-instagram"
                href="#"
                className="w-10 h-10 rounded-full glass-card flex items-center justify-center hover:border-cyan-400/40 transition-colors"
                aria-label="Instagram"
              >
                <Instagram className="w-4 h-4 text-zinc-300" />
              </a>
            </div>
          </div>
        </div>

        <div className="mt-14 pt-8 border-t border-white/5 flex flex-col md:flex-row items-center justify-between gap-4 text-xs text-zinc-500">
          <p>© 2026 SilentScan AI. All Rights Reserved.</p>
          <p className="text-zinc-500">
            Designed &amp; built by{" "}
            <span className="text-cyan-400 font-medium">Sajiith Vivan</span>
          </p>
          <p className="text-zinc-600">
            SilentScan AI is not a substitute for professional medical advice.
          </p>
        </div>
      </div>
    </footer>
  );
}
